import { forwardRef } from 'react'
import cn from 'clsx'
import type { TCollectionListProps } from './CollectionList.types'
import styles from './CollectionList.module.css'

export const CollectionList = forwardRef<HTMLUListElement, TCollectionListProps>(
    ({ className, ...props }, ref) => (
        <ul ref={ref} className={cn(styles.list, className)} {...props} />
    ),
)
